import { getContactFormSlugFromUrl } from 'app/utils/contactFormUrl';
import { shadowRoot } from 'app/shadowRoot';
import { create } from 'zustand';

export type ContactFormSource = 'widget' | 'nonWidget';

export type ContactFormLinkLocation =
  | 'footer'
  | 'topicSearchResult'
  | 'topicCategoryPage'
  | 'topicPinnedResource'
  | 'topicEmbedded'
  | 'vaResponse'
  | 'nbr'
  | 'dynamicButton'
  | 'vaSingleChoiceOptionClick'
  | 'pill'
  | 'relatedResource';

interface ContactFormState {
  isOpen: boolean;
  contactFormSlug?: string;
  openedThrough?: ContactFormLinkLocation;
  source: ContactFormSource;
  previouslyFocusedElement: HTMLElement | null;
  setOpenedThrough: (openedThrough: ContactFormLinkLocation) => void;
  openContactForm: (refSlug?: string, source?: ContactFormSource, openedThrough?: ContactFormLinkLocation) => void;
  closeContactForm: () => void;
}

export const useContactFormStore = create<ContactFormState>((set) => {
  const tailorUrlQueryParam = new URLSearchParams(window.location.search).get('tailorUrl');

  const contactFormSlug = getContactFormSlugFromUrl(tailorUrlQueryParam?.replace('/', '#'));

  return {
    isOpen: !!tailorUrlQueryParam?.startsWith('/contact-form'),
    contactFormSlug,
    source: 'widget',
    previouslyFocusedElement: null,
    setOpenedThrough: (openedThrough: ContactFormLinkLocation) => set({ openedThrough }),
    openContactForm: (slug?: string, source: ContactFormSource = 'widget', openedThrough?: ContactFormLinkLocation) => {
      const getFocusedElement = (): HTMLElement | null => {
        if (shadowRoot && shadowRoot.activeElement) {
          return shadowRoot.activeElement as HTMLElement;
        }
        return document.activeElement as HTMLElement;
      };

      set({
        isOpen: true,
        contactFormSlug: slug,
        source,
        openedThrough,
        previouslyFocusedElement: getFocusedElement(),
      });
    },
    closeContactForm: () =>
      set({
        isOpen: false,
        contactFormSlug: '',
        source: 'widget',
        openedThrough: undefined,
        previouslyFocusedElement: null,
      }),
  };
});

export default useContactFormStore;
